import { render, staticRenderFns } from "./MyReservations.vue?vue&type=template&id=85b1a710&"
import script from "./MyReservations.vue?vue&type=script&lang=js&"
export * from "./MyReservations.vue?vue&type=script&lang=js&"
import style0 from "./MyReservations.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports